// extracted by mini-css-extract-plugin
export default {"loder":"Loder_loder__1giRN"};